import { Cookies } from '@confluence/cookies';

const DOMAIN_SHARDING_KEY = 'cc.domain.sharding';

export const initializeFlag = () => {
	for (const entry of performance.getEntriesByType('resource')) {
		if (entry?.nextHopProtocol === 'http/1.1') {
			try {
				Cookies.set(DOMAIN_SHARDING_KEY, '1', {
					expires: 7,
				});
				return;
			} catch {}
		}
	}

	Cookies.remove(DOMAIN_SHARDING_KEY);
};
